/** InlineCellEditor — in-cell editor wrapping FieldValueInput with Enter=commit / Esc=cancel / blur=commit. */
import React from 'react'
import Box from '@mui/material/Box'
import { FieldValueInput } from './FieldValueInput'
import type { AttributeDef } from '../designer/services/configObjectApi'

export interface InlineCellEditorProps {
  attr: AttributeDef
  value: unknown
  connectionId: string
  onChange: (v: unknown) => void
  onCommit: () => void
  onCancel: () => void
}

export const InlineCellEditor: React.FC<InlineCellEditorProps> = ({ attr, value, connectionId, onChange, onCommit, onCancel }) => (
  <Box
    onKeyDown={(e) => {
      if (e.key === 'Enter') { e.preventDefault(); onCommit() }
      else if (e.key === 'Escape') { e.preventDefault(); onCancel() }
    }}
    onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget as Node)) onCommit() }}
    sx={{ minWidth: 120 }}
  >
    <FieldValueInput attr={attr} value={value} onChange={onChange} connectionId={connectionId} autoFocus />
  </Box>
)
